import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useToastContext from "hooks/useToastContext";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import OtpInput from "react18-input-otp";
import { apiPost } from "utils/apiFetch";
import ActionDialog from "./ActionDialog";
import ErrorMessage from "./ErrorMessage";

export default function OtpDialog({ otpURL, otpConfirmURL, body, onSuccess, onClose }) {
  const notification = useToastContext();
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState(null);
  const [otpError, setOtpError] = useState("");
  const [seconds, setSeconds] = useState(59);
  const [minutes, setMinutes] = useState(1);

  let timerRef;
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    timerRef = setInterval(() => {
      if (minutes >= 0) {
        if (seconds === 0) {
          if (minutes > 0) {
            setSeconds(60);
            setMinutes((prev) => prev - 1);
          } else {
            setSeconds(0);
          }
        } else {
          setSeconds((prev) => prev - 1);
        }
      } else {
        clearInterval(timerRef);
      }
    }, 1000);
    return () => clearInterval(timerRef);
  });

  const onSubmit = async () => {
    if (minutes === 0 && seconds === 0) {
      notification.error(t("OTP_EXPIRE"));
      return;
    }
    if (!otp) {
      setOtpError(t("OTP_REQUIRE"));
      return;
    } else {
      setOtpError("");
    }
    let res;
    try {
      setLoading(true);
      const sendData = {
        ...body,
        otp: otp,
      };

      res = await apiPost(otpConfirmURL, sendData);
      if (res.data.success) {
        onSuccess(res.data.message);
      } else {
        notification.error(res?.data?.message);
      }
    } catch (err) {} finally {
      setLoading(false);
    }
  };

  const handleChange = (value) => setOtp(value);

  const handleResendOtp = async () => {
    try {
      setLoading(true);
      if (minutes === 0 && seconds === 0) {
        const res = await apiPost(otpURL, body);
        if (res.data.success === true) {
          notification.success(res.data.message);
          setSeconds(59);
          setMinutes(1);
        } else {
          notification.error(res.data.message);
        }
      } else {
        notification.error(t("WAIT_FOR_OTP"));
      }
    } catch (err) {
    }
    setLoading(false);
  };

  useEffect(() => {
    if (otp) {
      setOtpError("");
    }
  }, [otp]);

  return (
    <ActionDialog title={t('VERIFY_OTP')} open={true} onClose={onClose}>
      <div className="flex items-center flex-col justify-center p-4">
        <div className="mb-4">
          <OtpInput
            inputStyle={{
              border: "1.5px solid var(--card-color)",
              width: "5rem",
              background: "transparent",
              height: "2.4rem",
              color: "var(--text-color)",
              fontWeight: "bold",
              marginRight: ".2rem",
              marginLeft: ".2rem",
              outline: "none",
              borderRadius: "8px",
            }}
            shouldAutoFocus
            isInputNum={true}
            value={otp}
            containerStyle="text-center mt-2"
            onChange={(value) => handleChange(value)}
            numInputs={4}
            separator={<span> </span>}
          />

          <ErrorMessage message={otpError} />
        </div>

        <div className="sm:w-full">
          {(seconds > 0 || minutes > 0) && (
            <div className="mb-4 d-flex justify-content-between mt-4">
              <div className="font-medium">
                {t("OTP_EXPIRING")} {minutes}:{seconds}
              </div>
            </div>
          )}
        </div>

        <div className="w-[95%] mt-5">
          {loading ? (
            <div className="btn btn_theme w-full flex items-center justify-center p-3">
              <FontAwesomeIcon icon={faCircleNotch} className="text-white text-xl animate-spin" />
            </div>
          ) : (
            <button type="submit" className="btn btn_theme w-full py-3 mb-3 text-white" onClick={onSubmit}>
              {t("O_VERIFY")}
            </button>
          )}
        </div>
        <div className="flex gap-1 text-center w-100 mb-2 mt-4">
          <span className="fw-bold">{t("DIDNT_RECEIVE_OTP?")}</span>
          <div onClick={handleResendOtp} className="link text-primary font-medium" style={{ cursor: "pointer" }}>
            {" "}
            {t("RESEND_OTP")}
          </div>
        </div>
      </div>
    </ActionDialog>
  );
}
